const c = {
  name: "Hands00011",
  dimensions: { width: 26, height: 38 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 26 38" style="enable-background:new 0 0 26 38;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M10,8c-1.7,0-3.2,1.1-3.8,2.7C5.6,10.2,4.8,10,4,10c-2.2,0-4,1.8-4,4v11c0,7.2,5.8,13,13,13s13-5.8,13-13V8.4
			C26,6.1,24.3,4,22,4c-0.7,0-1.4,0.2-2,0.6V3.4c0-0.9-0.6-1.8-1.2-2.3c-0.7-0.6-1.7-1-2.8-1l0,0c-2.2,0-4,1.8-4,4v4.5
			C11.4,8.2,10.7,8,10,8z M16,2C16,2,16.1,2,16,2c1.1,0,2,0.9,2,2v15h-4V4C14,2.9,14.9,2,16,2z M20,19V8.4C20,7,21,6,22,6s2,1,2,2.4
			V25c0,6.1-4.9,11-11,11C6.9,36,2,31.1,2,25v-4c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2s-0.9,2-2,2H6v2h4c2.2,0,4-1.8,4-4h8v-2H20z
			 M4,17c-0.7,0-1.4,0.2-2,0.5V14c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2v3H4z M8,12c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2v5.5
			c-0.6-0.3-1.3-0.5-2-0.5H8V12z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Hands00011
};
